'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducerMap;

var _fp = require('lodash/fp');

var _yourchoice = require('yourchoice');

var _setItems = require('./setItems');

var _rangeTo = require('./rangeTo');

var _remove = require('./remove');

var _removeAll = require('./removeAll');

var _replace = require('./replace');

var _setSelection = require('./setSelection');

var _toggle = require('./toggle');

var _actionTypes = require('./actionTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reducerMap = (_reducerMap = {}, _defineProperty(_reducerMap, _actionTypes.RANGE_TO, _rangeTo.rangeToReducer), _defineProperty(_reducerMap, _actionTypes.REMOVE, _remove.removeReducer), _defineProperty(_reducerMap, _actionTypes.REMOVE_ALL, _removeAll.removeAllReducer), _defineProperty(_reducerMap, _actionTypes.REPLACE, _replace.replaceReducer), _defineProperty(_reducerMap, _actionTypes.TOGGLE, _toggle.toggleReducer), _defineProperty(_reducerMap, _actionTypes.SET_SELECTION, _setSelection.setSelectionReducer), _defineProperty(_reducerMap, _actionTypes.SET_ITEMS, _setItems.setItemsReducer), _reducerMap);

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var nextState = state;
  if (!action || action.error || !action.payload || !action.payload.selectionName) {
    return nextState;
  }
  var selectionName = action.payload.selectionName;
  if (!(selectionName in nextState)) {
    nextState = (0, _fp.set)(selectionName, (0, _yourchoice.init)(), nextState);
  }

  if ((0, _fp.has)(action.type, reducerMap)) {
    return (0, _fp.update)(selectionName, (0, _fp.curry)(reducerMap[action.type])(action.payload), nextState);
  }
  return nextState;
};

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice-redux/lib/reducer.js
// module id = 158
// module chunks = 0